import { State, StateParams } from 'models/State'

import { api, usePrefetchNow } from '../api'

export const statesApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getStates: builder.query<State[], StateParams>({
      query: ({ countryCode }) => `/states?countryCode=${countryCode}`,
    }),
  }),
})

/**
 * Export the query hooks as well as the endpoints (for SSR).
 */
export const {
  endpoints: { getStates },
  useGetStatesQuery,
} = statesApi

export const usePrefetchStateMethods = (countryCode: string) =>
  usePrefetchNow(getStates, { countryCode })
